import React from 'react';
import { List, ListItem, ListSubheader } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ImageSectionsListProps } from '../../types';
import { popupStyles } from '../styles/popupStyles';
import ViewProImagesButton from './ViewProImagesButton';
import { SECTION_KEYS } from '../utils/selectionUtils';
import { LABELS } from '../constants';

const styles = (theme: any) => ({
  listSubHeader: popupStyles(theme).listSubHeader,
  listSubHeaderWithSpacing: {
    ...popupStyles(theme).listSubHeader,
    marginTop: '16px',
  },
  listItem: popupStyles(theme).listItem,
  listItemSelected: popupStyles(theme).listItemSelected,
  listContainer: popupStyles(theme).listContainer,
});

const ImageSectionsList: React.FC<ImageSectionsListProps> = ({
  proNumber,
  imageGroups,
  selectedKey,
  onSelect,
  hasIframe = false,
  onLoadProImages,
  loading = false,
  error = null,
  classes
}) => {
  const isIframeSelected = selectedKey === SECTION_KEYS.CARRIER_IMAGES;
  const hasImageData = imageGroups.length > 0;
  const totalImageCount = imageGroups.reduce((sum, group) => sum + group.images.length, 0);
  // Show Load button only when: iframe exists, no image data, no error, not loading, and API config exists
  const shouldShowLoadButton = hasIframe && !hasImageData && !error && !loading && onLoadProImages;
  const shouldShowProImagesSection = onLoadProImages || hasImageData || error;

  return (
    <List className={classes.listContainer}>
      {hasIframe && (
        <>
          <ListSubheader className={classes.listSubHeader}>
            {LABELS.CARRIER_IMAGES}
          </ListSubheader>
          {proNumber && (
            <ListItem
              classes={{
                root: classes.listItem,
                selected: classes.listItemSelected,
              }}
              selected={isIframeSelected}
              onClick={() => onSelect(SECTION_KEYS.CARRIER_IMAGES)}
            >
              {proNumber}
            </ListItem>
          )}
        </>
      )}

      {shouldShowProImagesSection && (
        <>
          <ListSubheader className={hasIframe ? classes.listSubHeaderWithSpacing : classes.listSubHeader}>
            {LABELS.PRO_IMAGES}
          </ListSubheader>
          
          {shouldShowLoadButton ? (
            <ViewProImagesButton
              onLoadProImages={onLoadProImages!}
              onSelect={onSelect}
            />
          ) : (
            <>
              <ListItem
                classes={{
                  root: classes.listItem,
                  selected: classes.listItemSelected,
                }}
                selected={selectedKey === SECTION_KEYS.PRO_IMAGES}
                onClick={() => onSelect(SECTION_KEYS.PRO_IMAGES)}
              >
                {LABELS.ALL_IMAGES}
                {hasImageData && <span>({totalImageCount})</span>}
              </ListItem>

              {imageGroups.map((group) => {
                const imageCount = group.images.length;
                const isSelected = selectedKey === group.key;
                
                return (
                  <ListItem
                    key={group.key}
                    classes={{
                      root: classes.listItem,
                      selected: classes.listItemSelected,
                    }}
                    selected={isSelected}
                    onClick={() => onSelect(group.key)}
                  >
                    {group.label}
                    {imageCount > 0 && <span>({imageCount})</span>}
                  </ListItem>
                );
              })}
            </>
          )}
        </>
      )}
    </List>
  );
};

export default withStyles(styles)(ImageSectionsList);
